<div class="personal-details">
    <div class="modal-body text-center">
        <p>Are you sure you want to delete this product composition?</p>
        <div class="mt-4">
            <button type="button" class="btn btn-secondary mr-2" (click)="cancel()">Cancel</button>
            <button type="button" class="btn btn-danger" (click)="delete()">Delete</button>
        </div>
    </div>
</div>